import {createFileRoute, redirect} from "@tanstack/react-router";
import {ErrorComponent} from "./-errorComponent";
import {NotFoundComponent} from "./-notFoundComponent";
import {PendingComponent} from "./-pendingComponent";
import {RouteComponent} from "./-routeComponent";
import {getGeographyWithCaching} from "~/utilities/geographyQueries";

export const Route = createFileRoute("/_withAuthenticationStatus/_authenticated/_withProfileStatus/_profileCompleted")({
    beforeLoad: async ({context}) => {
        // #region 727b4576-3be0-4f95-9a4b-bf89ce70fd75
        if (context.profileStatus.isProfileCompleted !== true) {
            console.groupCollapsed("User does not have a completed profile, redirecting to profile completion");
            console.log("profileStatus", context.profileStatus);
            console.groupEnd();

            throw redirect({
                // TODO: Get this from heimdallConfiguration or something
                href: "/set-profile",
                // TODO: Having to add this because.. idk, we are getting a blank screen without it in simulation.
                //       ref: 412ba837-f619-4f24-b94b-f6ea79db36db
                reloadDocument: true,
            });
        }
        // #endregion

        return {profileStatus: context.profileStatus};
    },
    loader: async ({context}) => {
        const geography = await getGeographyWithCaching({
            intellsysBaseUrl: context.intellsysBaseUrl,
            queryClient: context.queryClient,
        });
        return {
            geography: geography,
            platformUser: context.profileStatus.platformUser,
            platformAuthorizationDetails: context.platformAuthorizationDetails,
        };
    },
    staleTime: Infinity,
    component: RouteComponent,
    errorComponent: ErrorComponent,
    pendingComponent: PendingComponent,
    notFoundComponent: NotFoundComponent,
});
